var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgSuperchainStar = function SvgSuperchainStar(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 64,
    viewBox: "0 0 62 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2004_58579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.3047 0.672629C30.6924 0.297595 31.3076 0.297595 31.6953 0.672629L38.5595 7.31307C38.7812 7.52753 39.0894 7.62769 39.3948 7.58449L48.8513 6.24694C49.3853 6.1714 49.8831 6.53303 49.9763 7.06431L51.6264 16.4712C51.6797 16.775 51.8702 17.0372 52.1426 17.1818L60.5792 21.658C61.0557 21.9108 61.2458 22.496 61.009 22.9806L56.8147 31.5608C56.6792 31.8379 56.6792 32.1621 56.8147 32.4392L61.009 41.0194C61.2458 41.504 61.0557 42.0891 60.5792 42.342L52.1426 46.8182C51.8702 46.9628 51.6797 47.225 51.6264 47.5288L49.9763 56.9357C49.8831 57.467 49.3853 57.8286 48.8513 57.7531L39.3948 56.4155C39.0894 56.3723 38.7812 56.4725 38.5595 56.6869L31.6953 63.3274C31.3076 63.7024 30.6924 63.7024 30.3047 63.3274L23.4405 56.6869C23.2188 56.4725 22.9106 56.3723 22.6052 56.4155L13.1487 57.7531C12.6147 57.8286 12.1169 57.467 12.0237 56.9357L10.3736 47.5288C10.3203 47.225 10.1298 46.9628 9.85735 46.8182L1.42076 42.342C0.944281 42.0891 0.75416 41.504 0.991041 41.0194L5.18532 32.4392C5.32078 32.1621 5.32078 31.8379 5.18532 31.5608L0.991041 22.9806C0.75416 22.496 0.944281 21.9108 1.42076 21.658L9.85735 17.1818C10.1298 17.0372 10.3203 16.775 10.3736 16.4712L12.0237 7.06431C12.1169 6.53303 12.6147 6.1714 13.1487 6.24694L22.6052 7.58449C22.9106 7.62769 23.2188 7.52753 23.4405 7.31307L30.3047 0.672629Z",
    fill: "#FF0420"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2004_58579",
    x: 0.88916,
    y: 0.391357,
    width: 60.2217,
    height: 63.2173,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2004_58579"
  })))));
};
export default SvgSuperchainStar;